import { render, staticRenderFns } from "./layoutFull.vue?vue&type=template&id=bf42bfac&scoped=true&"
import script from "./layoutFull.vue?vue&type=script&lang=js&"
export * from "./layoutFull.vue?vue&type=script&lang=js&"
import style0 from "./layoutFull.vue?vue&type=style&index=0&id=bf42bfac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf42bfac",
  null
  
)

export default component.exports